import React, { useCallback, useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { useMutation } from 'react-query'
import { useNavigate } from 'react-router-dom'
import { useSnackbar } from 'notistack'
import Div from '@jumbo/shared/Div'
import reportDataServices from 'app/services/pages/reports/report-data-services'
import { getEnrolmentListReport } from 'app/redux/store/features/reports'
import EnrolmentListReportLayout from './EnrolmentListReportLayout'

const EnrolmentListReport = () => {
    const dispatch = useDispatch()
    const itemsPerPage = 25
    const [apiCallInProgress, setApiCallInProgress] = useState(false)
    const [imageData, setImageData] = useState('')
    const [pdfData, setPdfData] = useState({})
    const { enqueueSnackbar } = useSnackbar()
    const navigate = useNavigate()

    const [reportFilter, setReportFilter] = useState({
        customerId: null,
        memberId: null,
        familyId: null,
        termId: null,
        classId: null,
        sectionId: null,
        sort: '',
    })
    const handleError = useCallback(
        (error) => {
            if (error.status === '401') {
                navigate('/profile/signout')
            } else if (error.detail) {
                enqueueSnackbar(error.detail, {
                    variant: 'error',
                    anchorOrigin: {
                        vertical: 'top',
                        horizontal: 'right',
                    },
                })
            } else {
                enqueueSnackbar(error, {
                    variant: 'error',
                    anchorOrigin: {
                        vertical: 'top',
                        horizontal: 'right',
                    },
                })
            }
        },
        [enqueueSnackbar, navigate]
    )

    const applyViewFilter = useMutation({
        mutationFn: async (viewFilter) => {
            const filter = { ...viewFilter, skip: 0, take: itemsPerPage }
            setReportFilter(filter)
            dispatch(getEnrolmentListReport(filter))
        },
    })

    const applyPageChange = useMutation({
        mutationFn: async (page) => {
            const filter = { ...reportFilter, skip: (page - 1) * itemsPerPage, take: itemsPerPage }
            setReportFilter(filter)
            dispatch(getEnrolmentListReport(filter))
        },
    })

    const applyPdfFilter = useMutation({
        mutationFn: async () => {
            const filter = { ...reportFilter, skip: 0, take: 2000 }
            const data = await fetchData(filter)
            setPdfData(data)
            return data
        },
    })

    const fetchData = useCallback(async (filter) => {
        const reportData = await reportDataServices.getEnrolmentListReportData(filter, handleError)
        return reportData
    }, [])

    useEffect(async () => {
        setApiCallInProgress(true)
        const image = await reportDataServices.getImage()
        const imageData = image.data ? image.data : ''
        setImageData(imageData)
        dispatch(getEnrolmentListReport({ ...reportFilter, skip: 0, take: itemsPerPage }))
    }, [dispatch])

    return (
        <Div>
            <EnrolmentListReportLayout
                imageData={imageData}
                viewMutation={applyViewFilter}
                pdfMutation={applyPdfFilter}
                pageMutation={applyPageChange}
                apiCallInProgress={apiCallInProgress}
                setApiCallInProgress={setApiCallInProgress}
                pdfData={pdfData}
            />
        </Div>
    )
}

export default EnrolmentListReport
